import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/home/runner/work/gift-nuxt/gift-nuxt/layouts/checkout.vue")),
  default: defineAsyncComponent(() => import("/home/runner/work/gift-nuxt/gift-nuxt/layouts/default.vue"))
}